import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { AiOutlineUserDelete } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import { BsDash } from "react-icons/bs";
import Select from 'react-select';
import { API_URL } from "../../config";

function DashboardCard22() {
  const { showToast } = useToast();
  const location = useLocation();
  const { item: initialData } = location.state || {};  // Obținem datele din location.state
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [data, setData] = useState([]);
  const [Manage1, setManage1] = useState([]);
  const [valueuser, setValueuser] = useState([]);
  const [defaultOption, setDefaultOption] = useState('');  // Default value should be role_id
  const [speciality, setSpeciality] = useState([]);
  const [instcity, setinstCity] = useState([]);
  const [city, setCity] = useState([]);
  const [inst, setInst] = useState([]);
  const [instdoc, setInstdoc] = useState([]);
  const [instdoc1, setInstdoc1] = useState(false);
  const [Nume_adres, setNume_adres] = useState({ inst: '', adres: '' });
  const [filteredAdress, setFilteredAdress] = useState([]);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
 // const [isLoading, setIsLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
  const getJwtFromCookies = () => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  };

  //const token = getJwtFromCookies();

  const token = localStorage.getItem('jwtToken');

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adress`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCity(response.data)
        // //////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/speciality`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setSpeciality(response.data);
        // //////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  //   useEffect(() => {
  //   axios
  //     .get(`${API_URL}/api/planningdetail`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then((response) => {
        
  //       const inst = data.map((i) => i.institute_assign_id);
  //     console.log(inst)
  //       const val = inst.map((id) => {
  //         return response.data.some((obj) => obj.obiect_type_id === 1 && obj.object_id === id);
  //       });
      
  //       console.log(val); // ex: [true, false, true] dacă doar primul și al treilea id sunt găsite
  //     })      
  //     .catch((error) => {
  //       console.error("Error fetching user data:", error);

  //     });
  // }, [ data]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adressinstitutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setinstCity(response.data)
        // //////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/institutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setInst(response.data)
        // //////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);

    // Cleanup pentru timer
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);  // decoded is the correct variable here
        setUser(decoded); // Store decoded user data
        //////////////////////////////////console.log(user)
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  const fetchManageData = () => {
    axios
      .get(`${API_URL}/api/physician`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const users = response.data.filter(
          (item) => item.physician_id === selectedEditRowData?.physician_id
        );
        if (users.length > 0) {
          const subordinateUserId = users.map((item) => item.physician_id);

          axios
            .get(`${API_URL}/api/physiciansinstitute`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              const users1 = response.data.filter((item) =>
                subordinateUserId.includes(item.physician_id)
              ).map((i) => i.speciality_id);

              const users2 = response.data.filter((item) =>
                subordinateUserId.includes(item.physician_id)
              );

              setData(users2);
              setInstdoc(response.data);             
            })
            .catch((error) => {
              console.error("Error fetching users data:", error);
            });

        } else {
          setData([])
        }
      })
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  };

  useEffect(() => {
    fetchManageData();
  }, [selectedEditRowData]);

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const currentItems = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    if (selecteddeleteuser) {
      deleteRowuser();
    }
  }, [selecteddeleteuser]);

  const dropdownOptions = speciality.map((role) => ({
    value: role.speciality_id,
    label: role.description
  }));

  const _onSelect = (selectedOption) => {
    //////////////////////console.log(selectedOption);
    setDefaultOption(selectedOption);  // Set the selected option
  };

  const handleOpenRows = () => {
    setOpen(true); // Deschide dialogul
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      await handleSave(); // Simulate the save operation
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false); // Re-enable the button after operation completes
    }
  };

  // const deleteRowuser = async () => {
  //   if (!selecteddeleteuser) return;

  //   try {
  //     await axios.put(
  //       `${API_URL}/api/deletephysiciansinstitute`, { institute_assign_id: selecteddeleteuser.institute_assign_id }
  //     );
  //     showToast({
  //       message: "Datele au fost sterse cu succes!",
  //       type: "success",
  //       icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
  //     });
  //     fetchManageData();
  //   } catch (error) {
  //     console.error("Error saving changes:", error);
  //     showToast({
  //       message: "Eroare la inserarea datelor!",
  //       type: "error",
  //       icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
  //     });
  //   }
  // };

  const deleteRowuser = async () => {
    if (!selecteddeleteuser) return;
  
    try {
      // 1. Obține toate intrările din planningdetail
      const response = await axios.get(`${API_URL}/api/planningdetail`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      // 2. Verifică dacă există acel id în planningdetail
      const idExists = response.data.some(
        (obj) =>
          obj.obiect_type_id === 1 &&
          obj.object_id === selecteddeleteuser.institute_assign_id
      );
  
      // 3. Dacă există, nu permite ștergerea
      if (idExists) {
        showToast({
          message: "Nu poți șterge această înregistrare pentru că este deja folosită în planificare.",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
        return;
      }
  
      // 4. Dacă nu există, continuă cu ștergerea
      await axios.put(`${API_URL}/api/deletephysiciansinstitute`, {
        institute_assign_id: selecteddeleteuser.institute_assign_id,
      });
  
      showToast({
        message: "Datele au fost șterse cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
  
      fetchManageData();
    } catch (error) {
      console.error("Error saving changes:", error);
      showToast({
        message: "Eroare la ștergerea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };
  
  const handleSave = async () => {
    try {
      await axios.post(`${API_URL}/api/physiciansinstitute`, {
        institution_id: valueuser.value, physician_id: selectedEditRowData.physician_id,
        speciality_id: defaultOption,
      });

      setDefaultOption('');
      setValueuser([]);
      setOpen(false);
      fetchManageData();
      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const organizerOptionsuser = instcity.map((role) => ({
    label: `${role.inst} - ${role.adres}`,
    value: role.id,
  }));

  const isDarkMode = document.documentElement.classList.contains('dark');

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
            <h2 className="font-semibold text-gray-800 dark:text-gray-100">Specialitatea</h2>
            {user?.role === "Admin" && (<button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
              onClick={handleOpenRows}
            >
              <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
              </svg>
              <span className="//max-xs:sr-only">Adauga</span>

              <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                  </Transition.Child>

                  <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Dialog.Panel className="w-full max-w-md transform  rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800 ">
                          <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                            Selectează specialitatea
                          </Dialog.Title>
                          <div className="relative mt-4">
                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Specialitatea</label>
                            <select
                              className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 `}  // Adaugă clasa pentru eroare
                              value={defaultOption}
                              onChange={(e) => _onSelect(e.target.value)}
                            >
                              <option value="" disabled>Alege specialitatea</option>
                              {dropdownOptions.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))}
                            </select>
                          </div>

                          <div className="relative mt-4">
                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                              Alege institutia
                            </label>

                            <Select
                              options={organizerOptionsuser}
                              placeholder="Select accesul la useri..."
                              classNamePrefix="react-select"
                              value={valueuser}
                              onChange={(selected) => setValueuser(selected)}
                              getOptionLabel={(e) => e.label}
                              getOptionValue={(e) => e.value}
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  width: '100%',
                                  padding: '0.75rem',
                                  borderRadius: '0.375rem',
                                  borderColor: '#424242',
                                  boxShadow: 'none',
                                  color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                  backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                  color: isDarkMode ? 'black' : base.backgroundColor,
                                }),
                                singleValue: provided => ({
                                  ...provided,
                                  color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                })
                              }}
                            />

                          </div>

                          <div className="mt-4 flex justify-end gap-2">
                            <button
                              className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                              onClick={() => setOpen(false)}
                            >
                              Anulează
                            </button>

                            <button
                              className={`btn ${isLoading
                                ? "bg-gray-500 text-gray-300"
                                : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                                }`}
                              onClick={handleButtonClick}
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <svg
                                  className="animate-spin fill-current shrink-0 xs:hidden"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="8"
                                    cy="8"
                                    r="7"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  />
                                  <path
                                    className="opacity-75"
                                    d="M12 2a6 6 0 000 12V2z"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  className="fill-current shrink-0 xs:hidden"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                              )}
                              <span className="//max-xs:sr-only">
                                {isLoading ? "Saving..." : "Salveaza detaliile"}
                              </span>
                            </button>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition>
            </button>)}

          </header>
          {data.length > 0 ? (

            <div className="p-3" >
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="table-auto w-full dark:text-gray-300">
                  {/* Table header */}
                  <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                    <tr>
                      <th className="p-2">
                        <div className="font-semibold text-left">Specialitatea</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-left">Institutia</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-left">Adresa</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-left">Oras</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-left">Regiunea</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Actiune</div>
                      </th>
                    </tr>
                  </thead>
                  {/* Table body */}
                  <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                    {currentItems.map((customer, index) => {
                      const matchdistrict = instcity
                        .filter((i) => i.id === customer.institution_in_adress_id)
                        .map((i) => i.adress_id);

                      const matchingCity1 = matchdistrict.length > 0
                        ? city.find((i) => matchdistrict.includes(i.adress_id))
                        : null;

                      return (
                        <tr
                          role="button"
                          key={customer.institute_assign_id}
                          className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"
                            } hover:bg-gray-200 dark:hover:bg-gray-600`}
                        >
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">{customer.spec}</div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">{customer.inst}</div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">
                              {matchingCity1 ? matchingCity1.description : "-"}
                            </div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">
                              {matchingCity1 ? matchingCity1.city_name : "-"}
                            </div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">
                              {matchingCity1 ? matchingCity1.district_name : "-"}
                            </div>
                          </td>
                          <td>
                            <div className="font-semibold text-center"
                              style={{
                                fontWeight: "bold",
                                fontSize: "20px"
                              }}
                            >
                              {user?.role === "Admin" ? (
                                <IconButton
                                  onClick={() => setSelecteddeleteuser(customer)}
                                  color="primary"
                                  sx={{
                                    fontSize: "16px",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: "#a4adad",
                                    },
                                  }}
                                >
                                  <AiOutlineUserDelete className=" dark:text-gray-100" />
                                </IconButton>) : (<BsDash className=" dark:text-gray-100" />)}</div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {data.length > 5 && (
                <div className="flex justify-center mt-4">
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentPage(index + 1)}
                      className={`px-4 py-2 text-sm font-medium ${currentPage === index + 1
                        ? "bg-gray-500 text-white"
                        : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                        }`}
                    >
                      {index + 1}
                    </button>
                  ))}

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">No speciality</h2>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardCard22;
